import { i18n } from "commonAssets/js/constants";
import { createElement } from "./createElement.js";
import { hideEmail } from "./hideEmail.js";

export function createOTPForm(email) {
    return createElement(
        "form",
        {
            id: "otp-form",
            method: "post",
        },
        [
            createElement(
                "p",
                {},
                [],
                `${i18n.getTranslation("otp_instructions_1")} ${hideEmail(email)}.<br>${i18n.getTranslation("otp_instructions_2")}`
            ),
            createElement("div", { class: "otp-inputs" }, [
                createElement("input", { type: "text" }),
                createElement("input", { type: "text" }),
                createElement("input", { type: "text" }),
                createElement("input", { type: "text" }),
                createElement("input", { type: "text" }),
                createElement("input", { type: "text" }),
            ]),
            createElement("div", { class: "row mt-3 mx-auto col-md-2" }, [
                createElement("input", {
                    type: "submit",
                    id: "submit-otp",
                    class: "btn btn-primary",
                    value: "Submit",
                }),
            ]),
        ]
    );
}
